 import {
     Base
 } from "//www.greenwellfarms.com/cdn/shop/t/53/assets/base.js?v=169946323862693207411733340615";
 class Media extends Base {
     constructor() {
         super();
     }

     init(selector) {

         if ("undefined" === typeof selector || null === selector) return this;
         this.set("el", selector);
         return this.prep();

     } //

     prep() {
         let the_item = this.get("el");
         the_item.list_image = the_item.querySelectorAll(".productView-thumbnail .image");
         the_item.image_hover = the_item.querySelector(".image-wrapper");
 
         return this.bind_events();

     } // 

     bind_events() {
         let the_item = this.get("el");
         the_item.list_image.forEach((item) => {
             item.addEventListener('click', this.handleChangeImage.bind(this))
         });

        

         return this;
     }

     


     handleChangeImage(event) {
         let the_item = this.get('el');

         const image = event.target.getAttribute("src");
       

         let newSrcThumbnail = the_item.image_hover;


         newSrcThumbnail.setAttribute("style",`background:url(${image })`);
        newSrcThumbnail.querySelector("img").setAttribute("src", image);

         the_item.list_image.forEach((item) => {
             item.parentElement.classList.remove("active")
         });
         //toggle active
         event.target.parentElement.classList.toggle("active");

     }


 }

 export {
     Media
 };